// extracted by mini-css-extract-plugin
export var boldText = "_37-4";
export var checkboxContainer = "_37-6";
export var closeIcon = "_37-i";
export var container = "_37-0";
export var drawer = "_37-8";
export var drawerContent = "_37-9";
export var extraSmallText = "_37-5";
export var fulfillmentGroupTable = "_37-e";
export var largeText = "_37-3";
export var loadingSpinnerContainer = "_37-j";
export var mediumText = "_37-2";
export var narrow = "_37-f";
export var notificationLink = "_37-l";
export var packageCheckIconContainer = "_37-7";
export var slideoutHeaderActions = "_37-g";
export var slideoutHeaderActionsShifted = "_37-h";
export var slideoutHeaderContainer = "_37-a";
export var slideoutModal = "_37-c";
export var stickyHeaderWrapper = "_37-b";
export var table = "_37-k";
export var tableContainer = "_37-d";
export var tertiaryText = "_37-1";